import sounds, { SFX } from "./Sounds";

const WARNING_SOUND_SECONDS = 10;
const BEGIN_LEVEL_DELAY_MS = 1000; /* Tiny grace period when level starts */

export class Clock {
  constructor(secondsLeft) {
    this.secondsLeft = secondsLeft;
    this.msRemainingInSecond = 1000 + BEGIN_LEVEL_DELAY_MS;
  }

  //Maybe you should just do the 1/60 thing here, because you want it to count down at 60fps.
  //It will only tick if the timing is right, so you don't need to double do the work
  tick(callback) {
    this.msRemainingInSecond -= 16.6;

    if (this.msRemainingInSecond <= 0) {
      this.msRemainingInSecond = 1000;
      this.secondsLeft -= 1;

      //Play SFX if we are close to the end
      if (this.secondsLeft <= WARNING_SOUND_SECONDS) {
        sounds.playSfx(SFX.TIME_WARNING);
      }

      //Notify callback
      callback();
    }
  }
}
